import axios from "axios";

const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_PARALLEL = 4; // số chunk upload song song (ổn định nhất)

/**
 * Upload file dạng chunk (song song)
 */
export async function uploadFileChunked(
    file: File,
    extraData: Record<string, string>,
    onProgress?: (percent: number) => void
) {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const uploadId = generateUUID();

    let uploaded = 0;
    let current = 0;

    // ================= UUID (KHÔNG DÙNG crypto để tránh lỗi Safari) =================
    function generateUUID(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // ================= UPLOAD 1 CHUNK =================
    async function uploadChunk(index: number) {
        const start = index * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const blob = file.slice(start, end);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("uploadId", uploadId);
        fd.append("index", index.toString());
        fd.append("total", totalChunks.toString());
        fd.append("fileName", file.name);

        // extra data (Title, ...)
        Object.keys(extraData).forEach(k => {
            fd.append(k, extraData[k]);
        });

        await axios.post("/api/file/chunk-video", fd, {
            timeout: 0, // tránh timeout khi file lớn
        });

        uploaded++;
        onProgress?.(Math.round((uploaded * 100) / totalChunks));
    }

    // ================= WORKER SONG SONG =================
    async function worker() {
        while (true) {
            const index = current++;
            if (index >= totalChunks) break;
            await uploadChunk(index);
        }
    }

    // ================= CHẠY MAX_PARALLEL WORKER =================
    await Promise.all(
        Array.from({ length: MAX_PARALLEL }, () => worker())
    );

    // ================= COMPLETE =================
    await axios.post("/api/file/complete-video", {
        uploadId,
        fileName: file.name,
        totalChunks,
        title: extraData.Title // ⚠️ backend của bạn yêu cầu
    });
}
